<div class="body-2 text-muted align-center" *ngIf="!simplifiedAuditLogs?.length">
  <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
  {{'general.api_audit_table_empty' | translate}}
</div>

<ng-container *ngIf="!utilService.isMobile && simplifiedAuditLogs?.length">
  <app-pagination [page]="page" [pageSize]="pageData.pageSize" [total]="pageData.total" (pageChange)="emitPageChange($event)"></app-pagination>
  <table class="report-table manual-alternating-color">
    <thead>
      <tr class="break-word">
        <th class="min-width"></th>
        <th>{{'general.api_audit_table_timestamp' | translate}}</th>
        <th>{{'general.api_audit_table_performer' | translate}}</th>
        <th *ngIf="showEntityType">{{'general.api_audit_table_entity_type' | translate}}</th>
        <th *ngIf="showAction">{{'general.api_audit_table_action' | translate}}</th>
        <th>{{'general.api_audit_table_changed_field' | translate}}</th>
        <th>{{'general.api_audit_table_before' | translate}}</th>
        <th>{{'general.api_audit_table_after' | translate}}</th>
        <th class="min-width"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let log of simplifiedAuditLogs; let even = even;">
        <tr [ngClass]="{'alternate' : even}">
          <td [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1">
            <button mat-button class="icon-button small" *ngIf="log.entries.length > 1" (click)="toggleAuditLogRow(log.id)">
              <mat-icon class="svg-icon" [svgIcon]="auditLogRowExpanded[log.id] ? 'arrow_up' : 'arrow_down'"></mat-icon>
            </button>
          </td>
          <td [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1">
            {{log.timestamp | moment: { format: viewService.conf.dateTimeFormatWithSeconds } }}
          </td>
          <td [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1">{{log.performer}}</td>
          <td [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1" *ngIf="showEntityType">{{log.entityType}}</td>
          <td class="break-word" [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1" *ngIf="showAction">{{('general.' + log.action) | translate}}</td>
          <td>{{log.entries[0]?.changedField}}</td>
          <td class="break-word" [ngClass]="{'text-warning': isEmpty(log.entries[0].after)}">{{!isEmpty(log.entries[0].before) ? log.entries[0]?.before : '-'}}</td>
          <td class="break-word" [ngClass]="{'text-success': isEmpty(log.entries[0].before)}">{{!isEmpty(log.entries[0].after) ? log.entries[0]?.after : '-'}}</td>
            <td class="align-right" [rowSpan]="auditLogRowExpanded[log.id] && log.entries.length > 1 ? (log.entries.length + 1) : 1">
              <button mat-button class="left-spacer icon-button input-button valign-middle" (click)="showJsonDifferenceModal(log)">
                <mat-icon class="svg-icon" [svgIcon]="'code'"></mat-icon>
              </button>
            </td>
        </tr>

        <ng-container *ngIf="auditLogRowExpanded[log.id]">
          <tr [ngClass]="{'alternate' : even}" *ngFor="let keyEntry of log.entries; let first = first">
            <ng-container *ngIf="!first">
              <td>{{keyEntry.changedField}}</td>
              <td [ngClass]="{'text-warning': isEmpty(keyEntry.after)}">{{!isEmpty(keyEntry.before) ? keyEntry.before : '-'}}</td>
              <td [ngClass]="{'text-success': isEmpty(keyEntry.before)}">{{!isEmpty(keyEntry.after) ? keyEntry.after : '-'}}</td>
            </ng-container>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
  <app-pagination [page]="page" [pageSize]="pageData.pageSize" [total]="pageData.total" (pageChange)="emitPageChange($event)"></app-pagination>
</ng-container>

<ng-container *ngIf="utilService.isMobile && simplifiedAuditLogs?.length">
  <app-pagination [page]="page" [pageSize]="pageData.pageSize" [total]="pageData.total" (pageChange)="emitPageChange($event)"></app-pagination>
  <div class="listing-block" *ngFor="let log of simplifiedAuditLogs; let last = last; let even = even" [ngClass]="{'last-block': last}">

    <div class="header-block flex flex-grow space-between">
      <div>
        <div class="heading-5 no-margin text-base break-word bold">
          {{log.timestamp | moment: { format: viewService.conf.dateTimeFormatWithSeconds } }}
        </div>
        <div class="break-word">
          <span>{{log.performer || '-'}}</span>
        </div>
        <div class="top-spacer" *ngIf="showAction">
          <span class="break-word">{{('general.' + log.action) | translate}}</span>
        </div>
      </div>
      <div class="white-space-no-wrap no-grow no-min-width">
        <div class="flex flex-end">
          <button mat-button class="left-spacer icon-button input-button small" (click)="showJsonDifferenceModal(log)">
            <mat-icon class="svg-icon" [svgIcon]="'code'"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <table class="mobile-max-width bottom-spacer">
      <tbody>
        <tr [ngClass]="{'alternate' : even}">
          <td [colSpan]="2">
            <hr class="no-margin">
          </td>
        </tr>

        <tr [ngClass]="{'alternate' : even}" *ngIf="showEntityType">
          <td class="bold break-word">{{'general.api_audit_table_entity_type' | translate}}</td>
          <td class="align-right break-word">{{log.entityType}}</td>
        </tr>

        <tr [ngClass]="{'alternate' : even}">
          <td class="bold break-word" [colSpan]="2">{{log.entries[0]?.changedField}}</td>
        </tr>

        <tr [ngClass]="{'alternate' : even}">
          <td class="break-word">{{'general.api_audit_table_before' | translate}}</td>
          <td class="align-right break-word" [ngClass]="{'text-warning': !log.entries[0]?.after}">{{log.entries[0]?.before || '-'}}</td>
        </tr>

        <tr [ngClass]="{'alternate' : even}">
          <td class="break-word">{{'general.api_audit_table_after' | translate}}</td>
          <td class="align-right break-word" [ngClass]="{'text-success': !log.entries[0]?.before}">{{log.entries[0]?.after || '-'}}</td>
        </tr>

        <ng-container *ngIf="auditLogRowExpanded[log.id]">
          <ng-container *ngFor="let entry of log.entries; let first = first; let last = last">
            <ng-container *ngIf="!first">
              <tr>
                <td [colSpan]="2">
                  <hr class="no-margin">
                </td>
              </tr>
              <tr>
                <td class="bold break-word" [colSpan]="2">{{entry.changedField}}</td>
              </tr>
              <tr>
                <td class="break-word">{{'general.api_audit_table_before' | translate}}</td>
                <td class="align-right break-word" [ngClass]="{'text-warning': !entry.after}">{{entry.before || '-'}}</td>
              </tr>
              <tr>
                <td class="break-word">{{'general.api_audit_table_after' | translate}}</td>
                <td class="align-right break-word" [ngClass]="{'text-success': !entry.before}">{{entry.after || '-'}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <tr *ngIf="log.entries.length > 1">
          <td class="align-center" [colSpan]="2">
            <a class="link body-3 bold" (click)="toggleAuditLogRow(log.id)">
              <mat-icon class="svg-icon" [svgIcon]="auditLogRowExpanded[log.id] ? 'arrow_up' : 'arrow_down'"></mat-icon>
              <span>
                    {{(auditLogRowExpanded[log.id] ? 'general.api_show_less' : 'general.api_show_more') | translate}}
              </span>
            </a>
          </td>
        </tr>

      </tbody>
    </table>
    <hr class="no-margin">
  </div>
  <app-pagination [page]="page" [pageSize]="pageData.pageSize" [total]="pageData.total" (pageChange)="emitPageChange($event)"></app-pagination>
</ng-container>
